module.exports = __webpack_public_path__ + "img/menu-logo.98389ad3.png";